import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Maladie from "@/pages/Maladie";
import VivreAvec from "@/pages/VivreAvec";
import SuiviMedical from "@/pages/SuiviMedical";
import Actions from "@/pages/Actions";
import Don from "@/pages/Don";
import LivreEsperance from "@/pages/LivreEsperance";
import Actualites, { ArticlePage } from "@/pages/Actualites";
import Contact from "@/pages/Contact";
import { MentionsLegales, Confidentialite } from "@/pages/Legal";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 150);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main id="contenu" className="pb-20 md:pb-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/la-maladie" element={<Maladie />} />
            <Route path="/vivre-avec" element={<VivreAvec />} />
            <Route path="/suivi-medical" element={<SuiviMedical />} />
            <Route path="/nos-actions" element={<Actions />} />
            <Route path="/faire-un-don" element={<Don />} />
            <Route path="/livre-espoir" element={<LivreEsperance />} />
            <Route path="/actualites" element={<Actualites />} />
            <Route path="/actualites/:slug" element={<ArticlePage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
